import React from 'react'
import vision from '../assets/vision.png';
import mission from '../assets/mission.png';

const VisionMission = () => {
  return (
      <>
    <div className=" mt-28 px-8 md:px-16 bg-primary flex items-center text-white">
      <div className="w-2/3 py-4 lg:py-14">
        <h3 className="text-xl lg:text-2xl font-semibold">Our Vision</h3>
        <p className="mt-2 lg:mt-4 text-sm lg:text-base">
          Our vision is to create a positive impact on the community through innovative solutions.
          Our mission is to deliver excellence in every project we undertake.
        </p>
      </div>
      <div className="w-1/2 flex justify-center">
        <img src={vision} alt="Vision" className="w-[250px] h-auto  md:mt-[-220px]" />
      </div>
      </div>

<div className="px-8 md:px-16 bg-secondary flex items-center text-white">
      <div className="w-2/5 flex justify-center">
        <img src={mission} alt="Vision" className="w-[250px] h-auto md:mb-[-140px]" />
      </div>

      <div className="w-3/5 py-4 lg:py-14">
        <h3 className="text-xl lg:text-2xl font-semibold">Our Mission</h3>
        <p className="mt-2 lg:mt-4 text-sm lg:text-base">
          
            To design and provide advanced solutions that address industry-specific challenges keeping human and machine safety as top priority. Through innovation, integrity, and excellence, we aim to deliver exceptional value and build lasting partnerships with our customers.

        </p>
      </div>
      
    </div>
    </>
  )
}

export default VisionMission;
